export default class AdsCounterHeader {
    constructor(element) {
        this.$element = $(element);
    }

    init() {
        var that = this;
        $.get("/api/v1/posts/count", function( data ) {
            that.$element.html(`<strong><span> ${data.formattedCount} </span> annunci</strong> di auto in Italia.`)
        }).fail(function() {
            that.$element.html("<span>Numero di annunci non disponibile</span>")
        });
    }
}
